import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_RICH_PLACEMENT_MULTI_ANCHOR = (
  ability: Ability,
): TypedDocumentNode<Data, Variables> => gql`
  query getRichPlacementMultiAnchor($workspaceId: ID!) {
    workspaceRichPlacementMultianchorConfiguration(workspaceId: $workspaceId) {
      ${permitFields<Data['workspaceRichPlacementMultianchorConfiguration']>({
        frequencyCappingEnabled: ability.can('read', 'GlobalSetupField-frequencyCapping'),
        impressionLimit: ability.can('read', 'GlobalSetupField-frequencyCapping'),
        timeWindow: ability.can('read', 'GlobalSetupField-frequencyCapping'),
      })}

      counterStyle
      customStyling
      desktopAdDisplaysBeforeRefresh
      displayAfterUserInteractionEnabled
      desktopSingleAdViewTime
      fullWidthModeEnabled
      mobileAdDisplaysBeforeRefresh
      mobileSingleAdViewTime
      showCloseButtonEnabled
    }
  }
`
